var Safari = 
{
    cachedVersion: null,

    version: function() 
    {
        if ( this.cachedVersion !== null )
        {
            return this.cachedVersion;
        }

        var ua = window.navigator.userAgent;
        var safari = ua.indexOf("Safari") > -1 && ua.indexOf('Chrome') === -1;

        if ( safari ) 
        {
            return this.cachedVersion = parseFloat( ua.substr(ua.lastIndexOf('Version/') + 8, 3) );
        }

        // other browser
        return this.cachedVersion = false;
    }
};